export default {
  sourceRating: [],
  isLoading: false,
  error: null,
};
